module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_10_american-village-a4723ab79516520d5451879c1851ad9a.jpg";